import { createContext, useContext, useState } from "react";

import { useHasFloatingWindowOfType } from "src/base-components/FloatingWindow/hooks";

type SelectedRows = Record<string, boolean>;
type OnSelectRowHandler = (
  updaterOrValue: SelectedRows | ((rows: SelectedRows) => SelectedRows),
) => void;

const CasesTableContext = createContext<{
  selectedRows: SelectedRows;
  onSelectRow: OnSelectRowHandler;
  isSelectionDisabled: boolean;
}>({
  selectedRows: {},
  onSelectRow: () => {},
  isSelectionDisabled: false,
});

export const CasesTableProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({});
  const isSelectionDisabled = useHasFloatingWindowOfType("cm-bulk-action");

  const value = {
    selectedRows,
    onSelectRow: setSelectedRows,
    isSelectionDisabled,
  };

  return <CasesTableContext value={value}>{children}</CasesTableContext>;
};

export const useCasesTableContext = () => {
  const context = useContext(CasesTableContext);

  if (!context) {
    throw new Error(
      "useCasesTableContext can only be called within CasesTableContext",
    );
  }

  return context;
};
